import { render, staticRenderFns } from "./IconTerminal.vue?vue&type=template&id=2ba9beda&"
import script from "./IconTerminal.vue?vue&type=script&lang=js&"
export * from "./IconTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports